import Vue from 'vue';
import API from './api';

window.phoneValidation = new Vue({
  el: "#phone-validation-app",
  data: {
    canSendCode: true,
    isCountingDown: false,
    hasPhoneExisted: false,
    timer: "05:00",
    errorMessage: null,
  },

  methods: {
    async sendCode() {
      const phone = this.$refs.phone.value;

      if (!/^09\d{2}-?\d{3}-?\d{3}$/.test(phone)) {
        alert(this.errorMessage);
        return;
      }

      this.isCountingDown = true;
      this.canSendCode = false;

      try {
        await API.register.sendCode(phone);
      } catch(error) {
        console.error(error);
        if (_.get(error, 'response.status') == 422) {
          alert(error.response.data.errors.phone);
          this.canSendCode = true;
          this.hasPhoneExisted = true;
          this.isCountingDown = false;
          return;
        }

        if (window.bugsnagClient) {
          window.bugsnagClient.notify(error);
        }
      }

      let timer = 60 * 5;
      let timerId = setInterval(() => {
        let minutes = parseInt(timer / 60, 10);
        let seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        this.timer = minutes + ":" + seconds;

        if (--timer < 0) {
          clearInterval(timerId);
          this.isCountingDown = false;
          this.canSendCode = true;
        }
      }, 1000);
    }
  },
});
